var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 404.694,
    height: 404.694,
    viewBox: "0 0 404.694 404.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cell-blue",
    d: "M21.319,202.347A181.028,181.028,0,1,1,202.347,383.375,181.028,181.028,0,0,1,21.319,202.347ZM202.347,0C90.594,0,0,90.594,0,202.347S90.594,404.694,202.347,404.694,404.694,314.1,404.694,202.347,314.1,0,202.347,0ZM156.8,170.449a59.49,59.49,0,0,0-4.9,5.192c4.154,26.113,32.047,51.631,45.7,62.314.264.215.548.449.851.7,7.2,5.907,25.028,20.547,33.57,17.7,2.83-.943,6.222-4.6,10.028-8.711,5.771-6.229,12.492-13.483,19.645-13.841,7.122,0,29.673,17.211,33.234,20.772,9.232,10.861-2.408,23.214-9.454,30.69-.654.694-1.268,1.345-1.822,1.95-20.771,20.771-45.7,11.869-75.963-2.967-43.916-21.958-83.678-61.72-99.108-115.725-11.275-39.762,23.145-65.874,36.2-62.907,8.225,2.057,13.779,17.919,17.817,29.454.624,1.781,1.211,3.459,1.767,4.967C170.5,157.02,163.5,163.877,156.8,170.449Z",
    fill: "#54b329",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellBlue);
export default __webpack_public_path__ + "static/media/cell-blue.bbfd1fee8ccfbee15ed9372d0d3a1142.svg";
export { ForwardRef as ReactComponent };